import { render } from "./SectionBreakType.vue?vue&type=template&id=b0ec4f94"
import script from "./SectionBreakType.vue?vue&type=script&lang=js"
export * from "./SectionBreakType.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__